import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3.982 12a8 8 0 0 1 .5-2.79c.07.015.143.023.218.023h1.287a6.618 6.618 0 0 0 8.78 8.78V19.3c0 .075.008.148.024.219A8.018 8.018 0 0 1 3.983 12Zm15.537 2.79A8.018 8.018 0 0 0 9.209 4.48c.016.072.024.145.024.22v1.287a6.618 6.618 0 0 1 8.78 8.78H19.3c.075 0 .148.008.219.024Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 3.7a.7.7 0 0 1 .7-.7h5.533a.7.7 0 0 1 .7.7v5.533a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v4.133h4.133V4.4H4.4ZM14.067 14.767a.7.7 0 0 1 .7-.7H20.3a.7.7 0 0 1 .7.7V20.3a.7.7 0 0 1-.7.7h-5.533a.7.7 0 0 1-.7-.7v-5.533Zm1.4.7V19.6H19.6v-4.133h-4.133Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
